import { useLocation } from "react-router-dom";

export const useIsInTickets = () => {
  const location = useLocation();
  const isInTickets = location.pathname.includes("admin/tickets");
  return { isInTickets };
};
